import React, { FunctionComponent, ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { environment } from '../../../../../../../environments/environment';
import { Icon } from 'antd';

interface Props {
    priceWithDiscount: ReactNode;
    price: ReactNode;
    displayDiscount: boolean;
    priceLoading?: boolean;
}

const CartSummary: FunctionComponent<Props> = ({ price, priceWithDiscount, displayDiscount, priceLoading }) => {
    return (
        <div className="cart-summary">
            <div className="cart-summary__left">
                <Trans i18nKey="cart.priceTitle" />
            </div>
            <div className="cart-summary__right">
                {priceLoading ? (
                    <Icon type="loading" className="font-grey" />
                ) : (
                    <>
                        <div className="cart-summary__right__with-discount">{priceWithDiscount}</div>
                        {environment.config.dualPrices && displayDiscount &&
                            <div className="cart-summary__right__without-discount">
                                <Trans i18nKey="cart.priceOnPlace"/> {price}
                            </div>
                        }
                    </>
                )}
            </div>
        </div>
    );
};

export default CartSummary;
